interface GenericWebpackAsset {
	name: string
}

export const normalizeWebpackStats = (assets: Array<GenericWebpackAsset> | Array<string>): Array<string> => {
	if (assets.length === 0 || typeof assets[0] === 'string') {
		return assets as Array<string>
	}

	return (assets as Array<GenericWebpackAsset>).map(({ name }: GenericWebpackAsset) => name)
}
